import { createClient } from "@openauthjs/openauth/client";

const issuer =
  import.meta.env.VITE_AUTH_URL ??
  (import.meta.env.DEV ? "http://localhost:8610" : "https://auth.pahcertificar.com");

// Same OpenAuth client as the customer portal. The issuer's default redirect
// check allows any host sharing the pahcertificar.com apex (and localhost), so
// admin.pahcertificar.com is accepted without extra config.
export const authClient = createClient({
  clientID: "pahcertificar-app",
  issuer,
});

export const REDIRECT_URI = `${window.location.origin}/auth/callback`;

const TOKEN_KEY = "pahcertificar.admin.tokens";
const CHALLENGE_KEY = "pahcertificar.admin.challenge";
const POST_LOGIN_REDIRECT_KEY = "pahcertificar.admin.postLoginRedirect";

export type Tokens = { access: string; refresh: string };

export function loadTokens(): Tokens | null {
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    return raw ? (JSON.parse(raw) as Tokens) : null;
  } catch {
    return null;
  }
}

export function saveTokens(tokens: Tokens) {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(tokens));
}

export function clearTokens() {
  localStorage.removeItem(TOKEN_KEY);
}

export function saveChallenge(challenge: unknown) {
  sessionStorage.setItem(CHALLENGE_KEY, JSON.stringify(challenge));
}

export function takeChallenge(): { verifier: string; state: string } | null {
  const raw = sessionStorage.getItem(CHALLENGE_KEY);
  sessionStorage.removeItem(CHALLENGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as { verifier: string; state: string };
  } catch {
    return null;
  }
}

export function pushPostLoginRedirect(path: string) {
  if (path && path !== "/login" && !path.startsWith("/auth/")) {
    sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
  }
}

export function popPostLoginRedirect(): string | null {
  const value = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  return value;
}
